// extracted by mini-css-extract-plugin
export default {"container":"DetailedNotification_container__hTZfF","topRow":"DetailedNotification_topRow__rGUFN"};